import { Layout } from '@strapi/icons';

export const PluginIcon = () => <Layout />;
